import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { FilesService } from '../../../core/services/files.service';
import { ServicesService } from '../../../core/services/services.service';
import { FleetService } from '../../../core/services/fleet.service';
import { AppUtils } from '../../../core/config/app.utils';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { IDeactivateComponent } from '../../../core/guards/deactivate.gaurd';

const ADD_EDIT_SERVICE_VEHICLE_BOOK_IMAGE_UPLOAD =
  'ADD_EDIT_SERVICE_VEHICLE_BOOK_IMAGE_UPLOAD';

@Component({
  selector: 'app-add-edit-service',
  templateUrl: './add-edit-service.component.html',
  styleUrls: ['./add-edit-service.component.scss'],
})
export class AddEditServiceComponent implements OnInit, IDeactivateComponent {
  breadcrumbs: any[] = [];
  fleetId: any;
  serviceId: any;
  serviceForm: FormGroup | any;
  formErrors: any;
  actionListForm: FormGroup | any;
  actionListFormErrors: any;
  vehicleBookUploadFiles: any[] = [];
  serviceTypeVal = '';
  fleetData: any;
  serviceData: any;
  imageUploading = false;
  subbmit = false;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private servicesService: ServicesService,
    private fleetService: FleetService,
    private router: Router,
    private route: ActivatedRoute,
    private message: NzMessageService,
  ) {
    this.formErrors = {
      serviceType: {},
      currentMileage: {},
      remark: {},
    };
  }

  ngOnInit() {
    this.fleetId = this.route.snapshot.paramMap.get('fleetId');
    this.fleetService.getOneFleetById(this.fleetId).then((res) => {
      this.fleetData = res;
      this.setBreadCrumbs();
    });
    this.initServiceForm();

    if (this.route.snapshot.paramMap.get('id')) {
      this.serviceId = this.route.snapshot.paramMap.get('id');
      this.servicesService
        .getOneServiceInfoById(this.serviceId)
        .then((res: any) => {
          this.serviceData = res;
          this.serviceForm.patchValue(this.serviceData);
          this.actionListForm.patchValue(this.serviceData.actionList);
          this.vehicleBookUploadFiles = this.serviceData.attachments;
        });
    }

    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      if (res.type === ADD_EDIT_SERVICE_VEHICLE_BOOK_IMAGE_UPLOAD) {
        this.imageUploading = res.loading;
      }
    });
  }

  initServiceForm() {
    this.serviceForm = this.fb.group({
      serviceType: [null, Validators.required],
      currentMileage: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(15)]),
      ],
      remark: [null, Validators.maxLength(150)],
    });

    this.serviceForm.valueChanges.subscribe(() => {
      this.formErrors = AppUtils.getFormErrors(
        this.serviceForm,
        this.formErrors,
      );
    });
    this.initActionList();
  }

  initActionList() {
    this.actionListFormErrors = {
      isOilChange: {},
      isOilFilterChange: {},
      isTransIolCheck: {},
      isCoolantCheck: {},
      isBreakOilCheck: {},
      isNextBreakOilCheck: {},
      isAirFilterCheck: {},
      isNextAirFilterCheck: {},
      isBatteryCheck: {},
      isNextBatteryCheck: {},
      isCabinFilterCheck: {},

      isBreakPadCheck: {},
      isNextBreakPadCheck: {},
      isTypeCheck: {},
      isNextTypeCheck: {},

      isUnderCarriageCheck: {},
      isBootCheck: {},
      isOilLeakCheck: {},

      isWiperCheck: {},
      isNextWiperCheck: {},
      isHornCheck: {},
      isInteriorCheck: {},
      isACCheck: {},
      isBluetoothCheck: {},
      isInteriorLightCheck: {},
      isPowerMirrorCheck: {},
      isPowerShutterCheck: {},
      isHandBreakCheck: {},
      isSpareWheelCheck: {},
      isToolkitCheck: {},
      isGlueBottleCheck: {},

      isFrontHeadLightCheck: {},
      isFrontSignalLightCheck: {},
      isFogLightCheck: {},
      isWinkerLightCheck: {},
      isRearSignalLightCheck: {},
      isBreakLightCheck: {},
      isReversLightCheck: {},

      isCarpetWashCheck: {},
      isFullBodyWashCheck: {},
      isUnderCarriageWashCheck: {},
      isEngineGreasingCheck: {},
    };
    this.actionListForm = this.fb.group({
      isOilChange: [false],
      isOilFilterChange: [false],
      isTransIolCheck: [false],
      isCoolantCheck: [false],
      isBreakOilCheck: [false],
      isNextBreakOilCheck: [false],
      isAirFilterCheck: [false],
      isNextAirFilterCheck: [false],
      isBatteryCheck: [false],
      isNextBatteryCheck: [false],
      isCabinFilterCheck: [false],

      isBreakPadCheck: [false],
      isNextBreakPadCheck: [false],
      isTypeCheck: [false],
      isNextTypeCheck: [false],

      isUnderCarriageCheck: [false],
      isBootCheck: [false],
      isOilLeakCheck: [false],

      isWiperCheck: [false],
      isNextWiperCheck: [false],
      isHornCheck: [false],
      isInteriorCheck: [false],
      isACCheck: [false],
      isBluetoothCheck: [false],
      isInteriorLightCheck: [false],
      isPowerMirrorCheck: [false],
      isPowerShutterCheck: [false],
      isHandBreakCheck: [false],
      isSpareWheelCheck: [false],
      isToolkitCheck: [false],
      isGlueBottleCheck: [false],

      isFrontHeadLightCheck: [false],
      isFrontSignalLightCheck: [false],
      isFogLightCheck: [false],
      isWinkerLightCheck: [false],
      isRearSignalLightCheck: [false],
      isBreakLightCheck: [false],
      isReversLightCheck: [false],

      isCarpetWashCheck: [false],
      isFullBodyWashCheck: [false],
      isUnderCarriageWashCheck: [false],
      isEngineGreasingCheck: [false],
    });
  }

  setBreadCrumbs() {
    this.breadcrumbs = [
      {
        title: 'Fleets',
        icon: 'car',
        route: '/admin/fleets',
      },
      {
        title: this.fleetData.vehicleDetails?.registrationNumber,
        route: `/admin/fleets/${this.fleetId}`,
      },
      {
        title: ' Service Records ',
        route: [`/admin/fleets/${this.fleetId}`, { pageName: 'fleetService' }],
      },
      {
        title: this.serviceId ? ' Edit' : ' Add',
      },
    ];
  }

  vehicleBookUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_SERVICE_VEHICLE_BOOK_IMAGE_UPLOAD)
      .subscribe((res) => {
        const data = res as any;
        this.vehicleBookUploadFiles.push({
          name: item.file.name,
          url: data.url,
        });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_SERVICE_VEHICLE_BOOK_IMAGE_UPLOAD,
          loading: false,
        });
        this.message.create('success', `Attachment has been Uploaded!`);
      });

  removeUploadFile(index: any): void {
    this.vehicleBookUploadFiles.splice(index, 1);
    this.message.create('success', `Attachment has been deleted!`);
  }

  async serviceTypeCheck(event: string) {
    this.serviceTypeVal = event;
  }

  serviceTypeLabelVal(name: string) {
    let value = '-';
    switch (name) {
      case 'SR': {
        value = 'SR';
        break;
      }
      case 'OWNER': {
        value = 'Vehicle Owner';
        break;
      }
      default: {
        break;
      }
    }
    return value;
  }

  async submit() {
    const serviceFormData = this.serviceForm.getRawValue();
    let fleetUpdatePayload = {};
    const today = new Date();
    if (this.serviceTypeVal === 'TRANSMISSION') {
      fleetUpdatePayload = {
        _id: this.fleetId,
        currentMileage: serviceFormData.currentMileage,
        vehicleInventory: {
          ...this.fleetData?.vehicleInventory,
          latestOilChangedMileage: serviceFormData.currentMileage,
          latestOilChangeDate: moment(today).format(),
        },
      };
    } else {
      fleetUpdatePayload = {
        _id: this.fleetId,
        currentMileage: serviceFormData.currentMileage,
        vehicleInventory: {
          ...this.fleetData?.vehicleInventory,
          latestServiceMileage: serviceFormData.currentMileage,
          latestServiceDate: moment(today).format(),
        },
      };
    }
    const actionListFormData = this.actionListForm.getRawValue();
    if (this.serviceTypeVal !== 'TRANSMISSION') {
      delete actionListFormData.isTransIolCheck;
    }
    try {
      if (this.serviceId) {
        await this.servicesService
          .updateService({
            id: this.serviceId,
            fleet: this.fleetId,
            ...serviceFormData,
            attachments: this.vehicleBookUploadFiles,
            actionList: actionListFormData,
          })
          .subscribe(
            (res: any) => {
              this.fleetService.updateFleet(fleetUpdatePayload);
              this.subbmit = true;
              this.message.create(
                'success',
                `Service record has been Updated!!`,
              );
            },
            (error: any) => {
              console.log(error);
            },
          );
      } else {
        await this.servicesService
          .createService({
            fleet: this.fleetId,
            ...serviceFormData,
            attachments: this.vehicleBookUploadFiles,
            actionList: actionListFormData,
          })
          .subscribe(
            (res: any) => {
              this.subbmit = true;
              this.message.create(
                'success',
                `New service record has been added!!`,
              );
              this.fleetService.updateFleet(fleetUpdatePayload);
            },
            (error: any) => {
              console.log(error);
            },
          );
      }
      this.cancel();
    } catch (e) {
      console.log(e);
    }
  }

  cancel() {
    this.serviceForm.reset();
    this.actionListForm.reset();
    this.vehicleBookUploadFiles = [];
    this.router.navigate([
      `admin/fleets/${this.fleetId}`,
      { pageName: 'fleetService' },
    ]);
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.subbmit) {
      return true;
    } else if (this.serviceForm.dirty || this.serviceForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }
}
